import { UPDATE_TRACK } from "../actions/track";

export const updateTrackReducer = (state = '', action) => {
	switch (action.type) {
		case UPDATE_TRACK:
			return action.payload;
	}
	return state;
};
